import type { ConceptDef } from '../types';

export const intraverbalLetterSounds: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-letter-sounds',
  label: 'Intraverbal Letter Sounds',
  category: 'Intraverbal',
  description: 'Hear a letter sound; tap the letter that makes it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'What letter makes the buh sound?', answer: 'B' },
      { say: 'What letter makes the mmm sound?', answer: 'M' },
      { say: 'What letter makes the sss sound?', answer: 'S' },
      { say: 'What letter makes the tuh sound?', answer: 'T' },
      { say: 'What letter makes the puh sound?', answer: 'P' },
      { say: 'What letter makes the kuh sound?', answer: 'K' },
    ],
  },
};
